var $6fe2563fcd1fa25b$exports = {};
$6fe2563fcd1fa25b$exports = {
    "clear": `L\xf6schen`,
    "invalid": `(ung\xfcltig)`,
    "loading": `Wird geladen...`,
    "noResults": `Keine Ergebnisse`,
    "valid": `(g\xfcltig)`
};


export {$6fe2563fcd1fa25b$exports as default};
//# sourceMappingURL=de-DE.mjs.map
